var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentInstance,{tag:"component",attrs:{"landing":this.landing,"stadt":this.stadt,"staedteliste":this.staedte}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }